export default {
    // récuperer toutes les entites dans la base de données 
    get_all_entites(serverParams){
        return axios.post('/entite/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_balance_entites(tokens) {
        return axios.get('/authentite', {
            headers: {
                Authorization: "Bearer " + tokens
            }
        })
    },
    get_all_authentites(serverParams){
        return axios.get('/authentite?page=' + serverParams.page, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_typesentite(){
        return axios.get('/typesentite', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les entites dans la base de données 
    post_entites(entite){
        return axios.post('/entites',entite, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_entites(id,entite){
        
        return axios.put('/entites/'+id,entite, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_entites(id){
        return axios.get('/entites/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_entites(id){
        return axios.get('/desactive/entite/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    active_entites(id){
        return axios.get('/active/entite/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}